<template>
  <mobile-responsive-shell title="Ventes remarquées">
    <div class="sal-noticed">
      <div class="sal-noticed-filters card card-body py-3 mb-3">
        <div class="mb-2">
          <label class="form-label small mb-0">Client <span class="text-danger">*</span></label>
          <select v-model="filter.customer_reference" class="form-select form-select-sm" required>
            <option value="--">--</option>
            <option
              v-for="(customer, index) in customers"
              :key="index"
              :value="customer.reference"
              :style="
                customer.blocked || (customer.fullName && customer.fullName.includes('Bloqué'))
                  ? { color: 'red' }
                  : {}
              "
            >
              {{ customer.fullName }} {{ customer.society }}
            </option>
          </select>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-6">
            <label class="form-label small mb-0">Du <span class="text-danger">*</span></label>
            <input v-model="filter.startDate" type="date" class="form-control form-control-sm" />
          </div>
          <div class="col-6">
            <label class="form-label small mb-0">Au <span class="text-danger">*</span></label>
            <input v-model="filter.endDate" type="date" class="form-control form-control-sm" />
          </div>
        </div>
        <div class="mb-2">
          <label class="form-label small mb-0">État de paiement</label>
          <select v-model="filter.paymentStatus" class="form-select form-select-sm">
            <option value="--">--</option>
            <option value="Payé">Payé</option>
            <option value="Impayé">Impayé</option>
          </select>
        </div>
        <button type="button" class="btn btn-secondary btn-sm w-100" @click="toFilter(filter)">
          <i class="bi bi-funnel"></i> Rechercher
        </button>
      </div>

      <div class="sal-noticed-toolbar">
        <div class="form-check mb-0">
          <input
            id="sal-today"
            v-model="addedToday"
            class="form-check-input"
            type="checkbox"
            @change="listSales(addedToday)"
          />
          <label class="form-check-label small" for="sal-today">Ajoutée aujourd'hui</label>
        </div>
        <button type="button" class="btn btn-outline-secondary btn-sm" @click="refresh">
          <i class="bi bi-arrow-clockwise"></i>
        </button>
        <button
          type="button"
          class="btn btn-primary btn-sm"
          @click="$router.push({ name: 'mobile-sales-items-create' })"
        >
          <i class="bi bi-plus-square"></i> Nouvelle vente
        </button>
      </div>

      <p v-if="!filteredSales.length" class="text-muted text-center py-4">
        Aucune vente avec remarque.
      </p>

      <article
        v-for="(sale, idx) in filteredSales"
        :key="sale.reference || idx"
        class="sal-noticed-card"
      >
        <header class="sal-noticed-head">
          <span class="fw-bold">{{ sale.reference }}</span>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="
              $router.push({
                name: 'mobile-sales-details',
                params: { reference: sale.reference },
              })
            "
          >
            <i class="bi bi-info-square"></i>
          </button>
        </header>
        <div class="small">{{ sale.customerFullName }}</div>
        <div class="text-muted small">{{ sale.date }}</div>
        <div class="small">M. {{ sale.totalPriceTTC }} DH · payé <span class="text-success">{{ sale.amountPaid }}</span></div>
        <div v-if="sale.userName" class="small text-muted">{{ sale.userName }}</div>
        <div v-if="sale.remark" class="sal-noticed-remark small">{{ sale.remark }}</div>
      </article>
    </div>
  </mobile-responsive-shell>
</template>

<script>
import { mapGetters } from "vuex";
import MobileResponsiveShell from "../components/MobileResponsiveShell.vue";

export default {
  name: "MobileSalesNoticed",
  components: { MobileResponsiveShell },
  data() {
    return {
      addedToday: false,
      filter: {},
    };
  },
  computed: {
    ...mapGetters("sale", { sales: "getAll" }),
    ...mapGetters("customer", { customers: "getAll" }),
    filteredSales() {
      if (!this.sales || !this.sales.length) return [];
      return this.sales.filter((p) => p.remark);
    },
  },
  mounted() {
    this.$store.dispatch("sale/getAll");
    this.$store.dispatch("customer/getAll");
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("sale/getAll");
      await this.$store.dispatch("customer/getAll");
    },
    async listSales(checkbox) {
      if (checkbox === true) {
        await this.$store.dispatch("sale/getTodays");
      } else {
        await this.$store.dispatch("sale/getAll");
      }
    },
    async toFilter(data) {
      await this.$store.dispatch("sale/filter", data);
    },
  },
};
</script>

<style scoped>
.sal-noticed-filters {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.sal-noticed-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}
.sal-noticed-card {
  background: #fff;
  border-radius: 12px;
  padding: 0.875rem 1rem;
  margin-bottom: 0.65rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.sal-noticed-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
}
.sal-noticed-remark {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid #eee;
  color: #856404;
}
</style>
